import React, { useContext } from "react";
import { WhatsappShareButton } from "react-share";

import withStyles from '@mui/styles/withStyles';
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

import config from "../config";
import LanguageContext from "../LanguageContext";
import messages from "../services/messages";
import firebase from "../firebase";

const styles = (theme) => ({
  root: {
    margin: 0,
    minWidth: "20rem",
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const appUrl = config.appUrl;
const useDeepLinkShare = true;

export default function ShareDialog(props) {
  const language = useContext(LanguageContext);
  const getShareUrl = () => {
    return useDeepLinkShare ? props.url : appUrl;
  };

  return (
    <div>
      <Dialog
        onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
          {messages["share.dialog.title"][language]}
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {props.shareText} {props.url}
          </Typography>
        </DialogContent>
        <DialogActions>
          <WhatsappShareButton
            url={getShareUrl()}
            title={`${props.shareText}`}
            onClick={() => {
              firebase
                .analytics()
                .logEvent(`${props.classType}_shared_on_whatsapp`, {
                  mobile: props.mobile,
                  crop_name: props.cropName,
                  session_topic: props.sessionTopic,
                  week: props.week,
                  author_name: props.authorName,
                  position: props.position,
                  user_type: props.userType,
                  state: props.state ? props.state : "",
                  start_time: props.startTime ? props.startTime : "",
                  user_source: props?.userSource,
                });
            }}
          >
            <img
              src="../../icons/whatsapp.svg"
              alt="whatsapp"
              style={{ width: "30px", height: "30px" }}
            />
          </WhatsappShareButton>
          {/*<FacebookShareButton*/}
          {/*  url={getShareUrl()}*/}
          {/*  quote={`${props.shareText} ${props.url}`}*/}
          {/*  hashTag={"#HelpingFarmersWin"}*/}
          {/*  onClick={() => {*/}
          {/*    firebase.analytics().logEvent("class_shared_on_facebook", {*/}
          {/*      mobile: props.mobile,*/}
          {/*      crop_name: props.cropName,*/}
          {/*      author_name: props.authorName,*/}
          {/*      session_topic: props.sessionTopic,*/}
          {/*      week: props.week,*/}
          {/*      position: props.position,*/}
          {/*      user_source:props?.userSource*/}
          {/*    });*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <FacebookIcon size={32} round={true} />*/}
          {/*</FacebookShareButton>*/}
        </DialogActions>
      </Dialog>
    </div>
  );
}
